import { AppUpdateNotice } from "@/components/atomic-crm/misc/AppUpdateNotice";
import { i18nProvider } from "@/components/atomic-crm/providers/commons/i18nProvider";
import { CRM } from "@/components/atomic-crm/root/CRM";
import { I18nContextProvider } from "ra-core";

/**
 * Application entry point
 *
 * Customize Atomic CRM by passing props to the CRM component:
 *  - companySectors
 *  - darkTheme
 *  - dealCategories
 *  - dealPipelineStatuses
 *  - dealStages
 *  - lightTheme
 *  - darkModeLogo / lightModeLogo
 *  - noteStatuses
 *  - taskTypes
 *  - title
 * ... as well as all the props accepted by shadcn-admin-kit's <Admin> component.
 *
 * Logos must be an imported asset, an absolute URL, or a data URI — never a
 * route-relative path like "./img/logo.png", which breaks on nested routes.
 *
 * @example
 * import logoDark from "./logo-dark.svg";
 * import logoLight from "./logo-light.svg";
 *
 * const App = () => (
 *    <CRM
 *       darkModeLogo={logoDark}
 *       lightModeLogo={logoLight}
 *       title="Acme CRM"
 *    />
 * );
 */
const App = () => (
  <>
    <CRM />
    <I18nContextProvider value={i18nProvider}>
      <AppUpdateNotice />
    </I18nContextProvider>
  </>
);

export default App;
